export default interface IPessoaLookup {
  id: number;
  access_key: string;
  codigo: number;
  tipo_pessoa: string;
  vinculo_pessoa: string;
  nome: string;
  nome_fantasia?: string;
  inscricao_federal: string;
}

export const emptyPessoaLookup: IPessoaLookup = {
  id: 0,
  access_key: '',
  codigo: 0,
  tipo_pessoa: '',
  vinculo_pessoa: '',
  nome: '',
  nome_fantasia: '',
  inscricao_federal: '',
};
